import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  snapDefaultHacker,
  unSnapDefaultHacker,
} from "store/bailiff/(default)/hacker/default_hacker.action";
import {
  snapDefaultSetting,
  unSnapDefaultSetting,
} from "store/bailiff/(default)/setting/default_setting.action";
import {
  snapBailiffDocument,
  unSnapBailiffDocument,
} from "store/bailiff/bailiff/document/bailiff_document.action";
import {
  getBankData,
  snapBailiffJob,
  unSnapBailiffJob,
} from "store/bailiff/bailiff/job/bailiff_job.action";

//
//component
//redux
//selector
//actions
const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  // snap job (file chưa đóng tiền)
  useEffect(() => {
    dispatch(snapBailiffJob());
    return () => dispatch(unSnapBailiffJob());
  }, [dispatch]);

  // snap hacker
  useEffect(() => {
    dispatch(snapDefaultHacker());
    return () => dispatch(unSnapDefaultHacker());
  }, [dispatch]);

  // snap bailiff (file đã thanh toán)
  useEffect(() => {
    dispatch(snapBailiffDocument());
    return () => dispatch(unSnapBailiffDocument());
  }, [dispatch]);

  // snap setting
  useEffect(() => {
    dispatch(snapDefaultSetting());
    return () => dispatch(unSnapDefaultSetting());
  }, [dispatch]);

  // trigger banks.
  useEffect(() => {
    dispatch(getBankData());
  }, [dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
